import { ChangeDetectorRef, Component, OnInit, AfterContentChecked } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle';
import { AuthService } from './shared/services/auth.service';
import { ErrorDialogService } from './shared/errors/error-dialog.service';
import { Subscription, timer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, AfterContentChecked {
  showHead: string;
  minutes;
  subscription: Subscription;
  isLocalhost: boolean = false;

  constructor(
    private router: Router,
    private titleService: Title,
    private bnIdle: BnNgIdleService,
    private errorDialogService: ErrorDialogService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    const langExist = localStorage.getItem('locale');
    if (langExist) {
      this.translate.setDefaultLang(langExist);
      this.translate.use(langExist);
      localStorage.setItem('locale', langExist);
    } else {
      //get from server which language is selected
      localStorage.setItem('locale', 'en');
      this.translate.setDefaultLang('en');
      this.translate.use('en');
    }

    this.titleService.setTitle(environment.TITLE);
    this.bnIdle.startWatching(3600).subscribe(res => {
      if (res) {
        this.errorDialogService.closeDialog();
        sessionStorage.clear();
        this.router.navigateByUrl('/login');
        this.errorDialogService.openDialog('alert.sessionExpired', false);
      }
    });
  }

  refreshTokenService() {
    this.isLocalhost = window.location.hostname.includes('localhost');
    if (!this.isLocalhost) {
      this.authService.refreshPassToken().subscribe((res: any) => {
        sessionStorage.setItem('bid', JSON.stringify(res?.bid));
      });
    }
  }

  ngOnInit() {
    this.getUserStatus();
    this.minutes = 25 * 60 * 1000;
    if (sessionStorage.getItem('isLoggedIn') === 'true') {
      this.subscription = timer(0, this.minutes).subscribe(() => {
        this.refreshTokenService();
      });
    }
  }

  getUserStatus() {
    this.authService.data.subscribe(info => (this.showHead = info));
  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }
}
